<template>
  <v-container
    id="accounts-reports"
    tag="section"
  >
    <v-card>
      <v-card-title>
        {{ title }} <v-spacer />
        <v-btn color="secondary" @click="exportData">
<v-icon>mdi-download</v-icon>
</v-btn>
      </v-card-title>
      <v-card-text>
   <v-container>
    <v-row>
      <v-col>
        <v-text-field
            v-model="search"
            class="searchBox"
            append-icon="mdi-magnify"
            :label="$t('global.search')"
            single-line
            hide-details
            />
      </v-col>
        <v-spacer />
        <v-spacer />
        <v-spacer />
      <v-col>
        <template>
  <div class="text-center">
    <v-autocomplete
      v-model="period"
      :items="months"
      item-text="name"
      item-value="id"
      label="Select a period"
      return-object
      autocomplete="off"
      @change="selectMonth(period)"
    >
    <template v-slot:append-item />
    </v-autocomplete>
  </div>
</template>
      </v-col>
    </v-row>
  </v-container>
        <v-data-table
          filterable
          :headers="computedHeaders.map((x) => { return { ...x, text: $t(x.text) } })"
          :items="items"
          item-key="id"
          :loading="loading"
          :search="search"
          :items-per-page="rowsPerPage"
        >
        <template v-slot:item.organisation="{ item }">
        <a :href="createAccountDashboardURL(item)">
              {{ item.organisation }}
            </a>
        </template>
        <template v-slot:item.sessions="{ item }">
              {{ item.sessions }}
        </template>
        <template v-slot:item.activityChange="{ item }">
         <v-chip :color="activityChangeColor(item.activityChange)">
             {{ displayActivityChange(item.sessions, item.activityChange) }}
            </v-chip>
        </template>
        <template v-slot:item.recommend="{ item }">
           <v-chip :color="recommendColor(item.recommend, item.sessions)">
             <span> {{ item.recommend >=0 ? item.recommend + '%' : 'N/A' }}</span>
            </v-chip>
        </template>
        <template v-slot:item.registeredUsers="{ item }">
              {{ item.registeredUsers }}
        </template>
        <template v-slot:item.registeredAdmins="{ item }">
              {{ item.registeredAdmins }}
        </template>
        <template v-slot:item.maxUsers="{ item }">
              {{ item.maxUsers === 0 ? 'Unlimited': item.maxUsers }}
        </template>
        <template v-slot:item.maxDevices="{ item }">
             {{ item.maxDevices === 0 ? 'Unlimited': item.maxDevices }}
        </template>
        <template v-slot:item.maxSessions="{ item }">
             {{ item.maxSessions === 0 ? 'Unlimited': item.maxSessions }}
        </template>
        <template v-slot:item.expiryDate="{ item }">
              <span :class="textColor(item.expiryDate)">{{ displayTime(item.expiryDate) }}</span>
        </template>
        <template v-slot:item.ageMonths="{ item }">
              {{ item.ageMonths }}
        </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card v-if="userRoleIs('developer')">
      <v-card-title>Report Management</v-card-title>
      <v-card-text>
        <v-form>
          <date-range-picker :text-color="datePickerColor" @datesChange="reportDatesChanged" />
          <v-btn color="blue" :disabled="query.processingReport" @click="generateNewReport">
Create
</v-btn>
          <v-btn color="red" :disabled="query.processingReport" @click="deleteReport">
Delete
</v-btn>
          <p>
<span color="red">
          {{ error }}
        </span>
          </p>
        </v-form>
      </v-card-text>
    </v-card>
      <v-overlay :value="busy">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>
<script>
  import api from '@/helpers/api.js'
  import { Roles } from '@/helpers/users.js'
  import DateRangePicker from './DateRangePicker'
  import moment from 'moment'
  export default {
    name: 'AccountsReports',

    components: {
      'date-range-picker': DateRangePicker,
    },

    data () {
      return {
        title: 'Accounts report',
        reportType: 'AccountsReport',
        search: '',
        modal: false,
        datePickerColor: 'blacktext',
        loading: false,
        items: [],
        reports: [],
        period: new Date(new Date().setDate(0)).toISOString().substr(0, 7),
        months: [],
        accounts: [],
        rowsPerPage: 15,
        startDate: moment(this.period, 'YYYY/MM').startOf('month').toDate(),
        endDate: moment(this.period, 'YYYY/MM').endOf('month').toDate(),
        error: '',
        query: { startDate: moment().startOf('month').toDate(), endDate: moment().endOf('month').toDate(), processingReport: false },
        headers: [
          { text: 'accountsReports.headers.organisation', sortable: true, value: 'organisation' },
          { text: 'accountsReports.headers.sessions', sortable: true, value: 'sessions', align: 'center' },
          { text: 'accountsReports.headers.activity-change', sortable: true, value: 'activityChange', align: 'center' },
          { text: 'accountsReports.headers.recommend', sortable: true, value: 'recommend', align: 'center' },
          { text: 'accountsReports.headers.registered-users', sortable: true, value: 'registeredUsers', align: 'center' },
          { text: 'accountsReports.headers.registered-admins', sortable: true, value: 'registeredAdmins', align: 'center' },
          { text: 'accountsReports.headers.max-users', sortable: true, value: 'maxUsers', align: 'center' },
          { text: 'accountsReports.headers.max-devices', sortable: true, value: 'maxDevices', align: 'center' },
          { text: 'accountsReports.headers.max-sessions', sortable: true, value: 'maxSessions', align: 'center' },
          { text: 'accountsReports.headers.expiry', sortable: true, value: 'expiryDate', align: 'center' },
          { text: 'accountsReports.headers.age-months', sortable: true, value: 'ageMonths', align: 'center' },
        ],
      }
    },

    computed: {
      computedHeaders () {
        return this.headers
      },
      busy () {
        return this.loading
      },
    },
    watch: {
      period: async function () {
        await this.refreshItems()
      },
    },
    async mounted () {
      await this.refreshItems()
    },


    async created () {
      this.loading = true
      await this.getAllAccountsReport()
      await this.refreshItems()
      this.loading = false
    },
    methods: {
      displayActivityChange (sessions, activityChange) {
        let output = ''
        if (activityChange > 0) output = `+${activityChange}`
        output = activityChange
        const lastMonthsSessions = (sessions - activityChange)
        if (lastMonthsSessions > 0) {
          const percent = ((activityChange / lastMonthsSessions) * 100).toFixed()
          if (activityChange !== 0 && sessions) output += ` (${percent}%)`
        }
        return output
      },
      userRoleIs (role) {
        return (this.$store.getters.isAuthenticated && this.$store.getters.currentUserProfile.user.roles.includes(role))
      },
      reportDatesChanged (date) {
        this.query.startDate = date[0]
        this.query.endDate = date[1]
      },
      async generateNewReport () {
        // should validate
        console.log('start generate report')
        if (!this.query.startDate || !this.query.endDate) {
          console.error('no dates defined')
          return
        }
        try {
          this.query.processingReport = true
          await api.postAccountsReport(this.query.startDate, this.query.endDate)
          await this.getAllAccountsReport()
        } catch (ex) {
          this.error = ex.message
        }
        this.query.processingReport = false
        console.log('end report')
      },
      async deleteReport () {
        // should validate
        console.log('start delete report')
        if (!this.query.startDate || !this.query.endDate) {
          console.error('no dates defined')
          return
        }
        try {
          this.query.processingReport = true
          await api.deleteAccountsReport(this.query.startDate, this.query.endDate)
          await this.getAllAccountsReport()
        } catch (ex) {
          this.error = ex.message
        }
        this.query.processingReport = false
        console.log('end delete report')
      },
      createAccountDashboardURL (item) {
        return `#/admin/accounts/dashboard?account=${item.accountID}`
      },
      exportData () {
        let csv = 'Organisation,Sessions,Activity Change,Recommend, Registered Users,Registered Admin, Max Users,Max Devices,Max Sessions,Expiry, Age Month\n'
        this.items.forEach((row) => {
          csv += row.organisation + ',' + row.sessions + ',' + row.activityChange + ',' + row.recommend + ',' + row.registeredUsers + ',' + row.registeredAdmins + ',' + row.maxUsers + ',' + row.maxDevices + ',' + row.maxSessions + ',' + this.displayTime(row.expiryDate)
          csv += '\n'
        })
        const anchor = document.createElement('a')
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
        anchor.target = '_blank'
        anchor.download = 'Account Report.csv'
        anchor.click()
      },
      async selectMonth (date) {
        this.period = date
        this.startDate = moment(this.period, 'YYYY/MM').startOf('month').toDate()
        this.endDate = moment(this.period, 'YYYY/MM').endOf('month').toDate()
        this.modal = false
        await this.refreshItems()
      },
      async refreshItems () {
        this.startDate = moment(this.period, 'YYYY/MM').startOf('month').toDate()
        this.endDate = moment(this.period, 'YYYY/MM').endOf('month').toDate()
        this.items = this.getReport()
      },
      getReport () {
        const accountId = this.$store.getters.currentUserProfile.user.account
        let role
        if (this.$store.getters.currentUserProfile.user.roles.includes(Roles.SYSADMIN)) {
          role = Roles.SYSADMIN
          return this.getReportByRole(role)
        } else if (this.$store.getters.currentUserProfile.user.roles.includes(Roles.RESELLER)) {
          role = Roles.RESELLER
          return this.getReportByRoleAndResellerId(role, accountId)
        }
      },
      getReportByRole (role) {
        const report = this.reports.filter(r => {
          return moment(this.startDate).isSame(moment(r.startDate).format('YYYY-MM-DD')) && r.userType === role
        })
        const selectedReport = report.length > 0 ? report[0].monthlyData : []
        return selectedReport
      },
      getReportByRoleAndResellerId (role, resellerId) {
        const report = this.reports.filter(r => {
          return moment(this.startDate).isSame(moment(r.startDate).format('YYYY-MM-DD')) && r.userType === role && r.resellerId === resellerId
        })
        const selectedReport = report.length > 0 ? report[0].monthlyData : []
        return selectedReport
      },
      activityChangeColor (activityChange) {
        if (activityChange < 0) {
          return 'red lighten-1 white--text'
        } else if (activityChange > 0) {
          return 'green lighten-1 white--text'
        }
      },
      recommendColor (recommendPercentage, sessions) {
        if (recommendPercentage <= 60 && recommendPercentage >= 0 && sessions > 0) {
          return 'red lighten-1 white--text'
        } else if (recommendPercentage > 60 && recommendPercentage <= 80 && sessions > 0) {
          return 'orange lighten-2 white--text'
        } else if (recommendPercentage > 80 && sessions > 0) {
          return 'green lighten-1 white--text'
        }
      },
      textColor (time) {
        const currentTime = moment(this.period)
        const differenceInMonths = moment(time).diff(currentTime, 'months')
        return differenceInMonths <= 3 ? 'status' : ''
      },
      displayTime (time) {
        return moment(time).format('DD/MM/YY')
      },
      async getAllAccountsReport () {
        const reportIntervals = []
        this.reports = await api.getAllAccountsReport() || []
        for (let i = 0; i < this.reports.length; i++) {
          const startDate = moment(this.reports[i].startDate).format('YYYY-MM')
          reportIntervals.push(startDate)
        }
        this.months = reportIntervals
      },
    },

  }
</script>
<style>
.headers {
    font-size: 10px !important
}
.status {
  color: red;
  margin-left: -13px;
}
.recommend-red {
  background-color: red;
}
.recommend-orange {
  color: orange;
}
.recommend-green {
  color: green
}
</style>
